import PublicLayout from '@/layouts/PublicLayout.vue';
import LoginPage from '@/pages/LoginPage.vue';

export default [
  {
    path: '/login',
    component: PublicLayout,
    children: [
      {
        path: '',
        name: 'LoginPage',
        component: LoginPage,
        meta: { requiresAuth: false },
      },
    ],
  },
];
